import ResumeSection from "@/components/resume/ResumeSection";

export function ProjectsSection({ projects = [] }) {
  if (!projects.length) return null;
  return (
    <ResumeSection title="Projects" index={5}>
      <div className="space-y-3">
        {projects.map((p, idx) => (
          <div
            key={`proj-${idx}-${(p.name || "").slice(0, 24)}`}
            data-testid={`project-item-${idx}`}
          >
            <div className="font-heading font-bold text-base">{p.name}</div>
            {p.description && (
              <p className="text-[14.5px] leading-relaxed mt-1">
                {p.description}
              </p>
            )}
            {(p.technologies || []).length > 0 && (
              <div className="font-mono text-xs text-[var(--text-secondary)] uppercase tracking-wider mt-1">
                Tech: {p.technologies.join(", ")}
              </div>
            )}
          </div>
        ))}
      </div>
    </ResumeSection>
  );
}

export function CertificationsSection({ certifications = [] }) {
  if (!certifications.length) return null;
  return (
    <ResumeSection title="Certifications" index={6}>
      <div className="space-y-2">
        {certifications.map((c, idx) => (
          <div
            key={`cert-${idx}-${(c.name || "").slice(0, 24)}`}
            className="flex flex-wrap justify-between gap-2"
            data-testid={`certification-item-${idx}`}
          >
            <div className="font-heading font-bold text-base">{c.name}</div>
            <div className="font-mono text-xs text-[var(--text-secondary)] uppercase tracking-wider">
              {[c.issuer, c.date].filter(Boolean).join(" · ")}
            </div>
          </div>
        ))}
      </div>
    </ResumeSection>
  );
}

export function LanguagesSection({ languages = [] }) {
  if (!languages.length) return null;
  return (
    <ResumeSection title="Languages" index={7}>
      <div className="flex flex-wrap gap-2">
        {languages.map((l, i) => (
          <span
            key={`lang-${i}-${l.slice(0, 24)}`}
            className="px-3 py-1 border border-[var(--border-default)] text-xs font-medium"
          >
            {l}
          </span>
        ))}
      </div>
    </ResumeSection>
  );
}
